import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import PageHeader from "../components/PageHeader";
import axios from "axios";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import {
  dailyapi,
  visiongamesdailyapi,
  DigitizeDailyApi,

  DigitizePrevRevApi,
  VisiongamesprevRevApi,
  prevRevenueApi,
  
  RestartServiveApi,
  baseURL,
  WonderMindDailyApi,
  KickWinDailyApi,
  WonderMindPrevRevApi,
  KickwinPrevRevApi,
} from "../Data/api";

const ServiceTable = ({ api, onTotalRevenueUpdate }) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const lastErrorRef = React.useRef(null);

  const todayDayTemplate = () => moment().format("YYYY-MM-DD");

  const getData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(api, { timeout: 8000 });
      console.log(res, "==res==");
      const result = res.data?.result || [];
      setData(result);
      const revenue = result.reduce(
        (sum, row) => sum + (parseFloat(row.total_revenue) || 0),
        0,
      );
      onTotalRevenueUpdate(revenue); // send revenue to parent
      setLoading(false);
      lastErrorRef.current = null; // Clear last error on success
    } catch (err) {
      const errorKey = `${err.code}-${api}`;
      if (lastErrorRef.current !== errorKey) {
        console.error("Error fetching data from", api, ":", err.code);
        lastErrorRef.current = errorKey;
      }

      let errorMsg = "Error fetching data. ";
      if (err.code === "ECONNABORTED") {
        errorMsg +=
          "Request timeout. Please ensure backend server is running on port 9090.";
      } else if (err.code === "ERR_NETWORK") {
        errorMsg +=
          "Network error. Please check if the backend server is running.";
      } else {
        errorMsg += "Please try again later.";
      }
      setError(errorMsg);
      setData([]);
      onTotalRevenueUpdate(0); // set 0 on error
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
    const intervalId = setInterval(getData, 60000); // every 60 seconds instead of 30
    return () => clearInterval(intervalId); // cleanup on unmount
  }, [api]);

  const handleRetry = () => {
    setRetryCount(retryCount + 1);
    getData();
  };

  return (
    <div className="w-full py-2 md:py-6 overflow-x-auto">
      {loading && data.length === 0 ? (
        <div className="flex justify-center items-center py-12">
          <div className="text-center animate-fade-in">
            <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent"></div>
            <p className="text-slate-500 font-medium mt-4">Loading data...</p>
          </div>
        </div>
      ) : error ? (
        <div className="bg-red-50 border border-red-200 p-4 rounded-xl shadow-sm animate-fade-in">
          <div className="flex justify-between items-center">
            <p className="text-red-600 text-sm font-medium">{error}</p>
            <button
              onClick={handleRetry}
              className="bg-red-600 hover:bg-red-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 ml-4 flex-shrink-0"
            >
              Retry
            </button>
          </div>
        </div>
      ) : data.length > 0 ? (
        <DataTable
          value={data}
          className="w-full data-table-custom animate-fade-in"
        >
          <Column
            header="Date"
            body={(rowData) =>
              rowData?.date
                ? moment(rowData.date).format("YYYY-MM-DD")
                : moment().format("YYYY-MM-DD")
            }
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="Subscriptions"
            header="Subscriptions"
            body={(rowData) => rowData?.Subscriptions ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="paid_sub"
            header="Paid Sub"
            body={(rowData) => rowData?.paid_sub ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="total_paid_sub"
            header="Total Paid Sub"
            body={(rowData) => rowData?.total_paid_sub ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="unsub"
            header="Unsub"
            body={(rowData) => rowData?.unsub ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="REN"
            header="Ren"
            body={(rowData) => rowData?.REN ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="ren_revenue"
            header="Ren-Rev"
            body={(rowData) => rowData?.ren_revenue ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="sub_revenue"
            header="Sub-Rev"
            body={(rowData) => rowData?.sub_revenue ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="PAID_CR"
            header="Paid-Cr"
            body={(rowData) => rowData?.PAID_CR ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
          <Column
            field="total_revenue"
            header="Total Rev"
            body={(rowData) => rowData?.total_revenue ?? 0}
            className="border border-gray-300 px-2 md:px-4 py-2 text-left"
          />
        </DataTable>
      ) : (
        <div className="bg-primaryLight border border-primary/20 p-5 rounded-xl animate-fade-in">
          <p className="text-primary font-medium text-center">No data available for today</p>
        </div>
      )}
    </div>
  );
};

// Main component
const CheckHourlyLogs = () => {
  const services = [
    { name: "kiddoCraze", code: "KC", api: dailyapi },
    { name: "VisionGames", code: "VG", api: visiongamesdailyapi },
    { name: "DigitizeAi", code: "DA", api: DigitizeDailyApi },
    { name: "WonderMind", code: "WM", api: WonderMindDailyApi },
    { name: "KickWin", code: "KW", api: KickWinDailyApi },
  ];
  const [revenues, setRevenues] = useState({});
  const [prevTotalRevenue, setPrevTotalRevenue] = useState(0);
  const [loadingServices, setLoadingServices] = useState({});
  const [statusMessages, setStatusMessages] = useState({});
  // const [backendStatus, setBackendStatus] = useState(null);

  console.log(statusMessages, "==statusmessages");

  const handleRevenueUpdate = (serviceName, revenue) => {
    setRevenues((prev) => ({ ...prev, [serviceName]: revenue }));
  };

  const totalAllRevenue = Object.values(revenues).reduce((a, b) => a + b, 0);

  const handleButtonClick = async (serviceName) => {
    console.log("Restart clicked for:", serviceName);
    setLoadingServices((prev) => ({ ...prev, [serviceName]: true }));
    setStatusMessages((prev) => ({ ...prev, [serviceName]: "" }));

    try {
      const response = await axios.post(RestartServiveApi(serviceName));
      console.log("Service restarted successfully:", response.data);
      setLoadingServices((prev) => ({ ...prev, [serviceName]: false }));
      setStatusMessages((prev) => ({ ...prev, [serviceName]: "Restarted" }));
    } catch (error) {
      console.error(
        "Failed to restart service:",
        error.response?.data || error.message,
      );
      setLoadingServices((prev) => ({ ...prev, [serviceName]: false }));
      setStatusMessages((prev) => ({ ...prev, [serviceName]: "Try Again" }));
    } finally {
      setLoadingServices((prev) => ({ ...prev, [serviceName]: false }));
    }
  };

  useEffect(() => {
    const fetchPrevRevenue = async () => {
      try {
        const [res1, res2, res3, res4, res5] = await Promise.all([
          axios.get(DigitizePrevRevApi),
          axios.get(VisiongamesprevRevApi),
          axios.get(prevRevenueApi),
          axios.get(WonderMindPrevRevApi),
          axios.get(KickwinPrevRevApi),
        ]);

        const rev1 = res1.data?.result?.[0]?.total_revenue || 0;
        const rev2 = res2.data?.result?.[0]?.total_revenue || 0;
        const rev3 = res3.data?.result?.[0]?.total_revenue || 0;
        const rev4 = res4.data?.result?.[0]?.total_revenue || 0;
        const rev5 = res5.data?.result?.[0]?.total_revenue || 0;

        setPrevTotalRevenue(rev1 + rev2 + rev3 + rev4 + rev5);
      } catch (error) {
        console.error("Error fetching previous revenues:", error);
        setPrevTotalRevenue(0);
      }
    };

    fetchPrevRevenue();
  }, []);

  return (
    <Layout>
      <div className="flex flex-col items-center w-full">
        {services.map((service, index) => (
          <Card key={index} className="w-full mb-6 animate-fade-in">
            <div className="w-full flex flex-col gap-4">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full border-b border-slate-100 pb-4">
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-extrabold text-slate-800 tracking-tight">
                    {service.name.toUpperCase()} DAILY LOGS
                  </h2>
                </div>

                <div className="flex flex-col sm:items-end mt-4 sm:mt-0">
                  {loadingServices[service.name] ? (
                    <button
                      className="bg-primary/50 text-white font-medium py-2 px-5 rounded-xl shadow-sm cursor-not-allowed"
                      disabled
                    >
                      Restarting...
                    </button>
                  ) : statusMessages[service.name] === "Restarted" ? (
                    <span className="bg-green-100 text-green-700 font-bold py-2 px-5 rounded-xl border border-green-200">
                      Restarted
                    </span>
                  ) : statusMessages[service.name] === "Try Again" ? (
                    <span className="bg-red-100 text-red-700 font-bold py-2 px-5 rounded-xl border border-red-200">
                      Try Again
                    </span>
                  ) : (
                    <button
                      onClick={() => handleButtonClick(service.name)}
                      className="bg-primary hover:bg-primaryHover text-white font-medium py-2 px-5 rounded-xl shadow-[0_4px_12px_rgba(79,70,229,0.2)] hover:-translate-y-0.5 transition-all duration-200"
                    >
                      Restart
                    </button>
                  )}
                </div>
              </div>

              <ServiceTable
                api={service.api}
                onTotalRevenueUpdate={(revenue) =>
                  handleRevenueUpdate(service.name, revenue)
                }
              />
            </div>
          </Card>
        ))}

        <Card className="w-full mt-2 animate-fade-in bg-gradient-to-br from-slate-800 to-slate-900 border-none shadow-[0_12px_30px_rgba(0,0,0,0.15)]">
          <div className="flex flex-col md:flex-row justify-around items-center py-6 gap-8">
            <div className="text-center">
              <p className="text-slate-400 font-medium text-sm tracking-widest uppercase mb-2">Previous Day Revenue</p>
              <h1 className="text-3xl font-extrabold text-white">
                ₹{prevTotalRevenue.toLocaleString()}
              </h1>
            </div>

            <div className="w-px h-16 bg-slate-700 hidden md:block"></div>

            <div className="text-center">
              <p className="text-slate-400 font-medium text-sm tracking-widest uppercase mb-2">Today Total Revenue</p>
              <h1 className="text-4xl font-extrabold flex justify-center items-center gap-3">
                <span
                  className={`${totalAllRevenue > prevTotalRevenue ? "text-green-400" : totalAllRevenue < prevTotalRevenue ? "text-red-400" : "text-white"}`}
                >
                  ₹{totalAllRevenue.toLocaleString()}
                </span>
                {totalAllRevenue > prevTotalRevenue && (
                  <FaArrowUp className="text-green-400 text-2xl" />
                )}
                {totalAllRevenue < prevTotalRevenue && (
                  <FaArrowDown className="text-red-400 text-2xl" />
                )}
              </h1>
            </div>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default CheckHourlyLogs;
